"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Generates a random ID out of a mix of
 * uppercase letters.
 *
 * @param length The length of the ID.
 */
function generateShortId(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i += 1) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
exports.default = generateShortId;
//# sourceMappingURL=generateShortId.js.map